export const details = {
  fileName: "filename",
  brokerCount: "brokerCount",
  brokerNotFoundCount: "brokerNotFoundCount",
  created: "created",
  status: "status",
  errorCount: "errorCount"
}